export default __webpack_public_path__ + "static/media/Certilytics-Logo-Icons-8.bf961d5c.svg";